module.exports = __webpack_public_path__ + "static/media/Determinants.6f578d66.pdf";